import React from "react";

function CheckBoxInput (props: {
    labelName: string | undefined,
    inputName: string | undefined,
    checked: boolean,
    setChecked: (checked: boolean) => void,
    value?: string;
    disabled?: boolean;
}){

    const handleChange = () => {
        if (!props.disabled) {
            props.setChecked(!props.checked);
        }
    };

    return (
        <div className="mb-2 grid items-start justify-between">
            <label>
                <p className="text-gray-500">
                    {props.labelName}
                </p>
            </label>
            <div className="flex items-start justify-between">
                <input
                    className={`border-gray-400 w-7 focus:border-blue-900 focus:outline-none border-2 p-2 h-9 shadow-[0_4px_10px_rgba(0,0,0,0.03)] font-normal transition-colors rounded-lg [&:not(:placeholder-shown):not(:focus):invalid~span]:block invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-400 ${props.disabled ? "cursor-not-allowed opacity-50" : ""}`}
                    name={props.inputName || ''}
                    onChange={handleChange}
                    type="checkbox"
                    checked={props.checked}
                    disabled={props.disabled}
                />
            </div>

        </div>

    );
}

export default CheckBoxInput;